// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 372 ? "braintree" : chunkId) + "." + {"372":"670a2835","393":"5de9972e","655":"50bb4e41"}[chunkId] + ".chunk.css";
};